<template>
    <div>
    <el-row style="text-align:right;">
        <el-button  v-on:click="saveAdvanced()" size="large" type="danger">Save advanced</el-button>
    </el-row>
    <el-row>
        <el-col v-bind="columnProps">
            <el-row class="advancedHeader">Project specs</el-row>
            <el-row>
                <el-col :span="16">
                    <el-row>Deviation</el-row>
                    <el-row class="specDescription">Distribution-related setting</el-row>
                </el-col>
                <el-col :span="8" class="specControl">
                    <el-input-number id="videoInt" min="0" size="mini" v-model="advanced.data.deviation"></el-input-number>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="16">
                    <el-row>Video settings</el-row>
                    <el-row class="specDescription">Video recording option is measured in % where 0 - no videos at all.</el-row>
                </el-col>
                <el-col :span="8" class="specControl">
                    <el-input-number id="videoInt" min="0" size="mini" v-model="advanced.data.video_ratio"></el-input-number>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="16">
                    <el-row>Retries</el-row>
                    <el-row class="specDescription">Number of tries in case of task's failure.</el-row>
                </el-col>
                <el-col :span="8" class="specControl">
                    <el-select v-model="advanced.data.retry_num"  size="mini" placeholder="Select retry num count">
                        <el-option
                        v-for="item in retryNumOptions"
                        :key="item"
                        :label="item"
                        :value="item">
                        </el-option>
                    </el-select>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="16">
                    <el-row>Captcha</el-row>
                    <el-row class="specDescription">Enable anti-captcha resolving</el-row>
                </el-col>
                <el-col :span="8" class="specControl">
                    <el-switch
                        v-model="advanced.data.anticaptcha"
                        active-color="#13ce66"
                        inactive-color="#ff4949">
                    </el-switch>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="16">
                    <el-row>Day-off schedule</el-row>
                    <el-row class="specDescription">Reduce bot traffic on holidays and weekends</el-row>
                </el-col>
                <el-col :span="8" class="specControl">
                    <el-switch
                        v-model="advanced.data.enable_dayoff_schedule"
                        active-color="#13ce66"
                        inactive-color="#ff4949">
                    </el-switch>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="16">
                    <el-row>Browser</el-row>
                    <el-row class="specDescription">Choose browser</el-row>
                </el-col>
                <el-col :span="8" class="specControl">
                    <el-select id="firefox" v-model="advanced.data.browser"  size="mini" placeholder="Select mode">
                        <el-option
                            v-for="item in firefoxes"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="16">
                    <el-row>Proxy country</el-row>
                    <el-row class="specDescription">Choose user country in ISO format (US)</el-row>
                </el-col>
                <el-col :span="8" class="specControl">
                    <el-input
                        class="advTextInputs"
                        type="textarea"
                        placeholder="Please input languages in ISO format"
                        autosize
                        v-model="advanced.data.country_codes">
                    </el-input>
                </el-col>
            </el-row>
            <UiTags
                title="Pools"
                description="Force specific usage only of specific pools (even if exclusive)"
                :selected_tags="advanced.data.worker_pools"
                :tags_list="pools"
                v-model="advanced.data.worker_pools"
            >
            </UiTags>
            <UiTags
                title="Custom proxy tags"
                description="Choose custom proxy tags"
                :selected_tags="advanced.data.proxy_custom_tags"
                :tags_list="proxies_tags.custom_tags"
                v-model="advanced.data.proxy_custom_tags"
            >
            </UiTags>
            <UiTags
                title="System proxy tags"
                description="Choose system proxy tags"
                :selected_tags="advanced.data.proxy_system_tags"
                :tags_list="proxies_tags.system_tags"
                v-model="advanced.data.proxy_system_tags"
            >
            </UiTags>
        </el-col>
        <el-col v-bind="columnProps">
            <el-row class="advancedHeader">Profile specs</el-row>
            <el-row>
                <el-col :span="16">
                    <el-row>Returning users</el-row>
                    <el-row class="specDescription">Profile re-use rate (%)</el-row>
                </el-col>
                <el-col :span="8" class="specControl">
                    <el-input-number min="0" id="videoInt" size="mini" v-model="advanced.data.profile_usage_returning"></el-input-number>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="16">
                    <el-row>Cooldown</el-row>
                    <el-row class="specDescription">How many days must pass for profile to return</el-row>
                </el-col>
                <el-col :span="8" class="specControl">
                    <el-input class="advTextInputs" size="mini" v-model="advanced.data.profile_usage_cooldown"></el-input>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="16">
                    <el-row>Device and OS</el-row>
                    <el-row class="specDescription">Choose platform type</el-row>
                </el-col>
                <el-col :span="8" class="specControl">
                    <el-select id="firefox" v-model="advanced.data.device_type"  size="mini" placeholder="Select OS">
                        <el-option-group
                        v-for="group in osTypes"
                        :key="group.label"
                        :label="group.label">
                        <el-option
                            v-for="item in group.options"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value">
                        </el-option>
                        </el-option-group>
                    </el-select>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="16">
                    <el-row>Language</el-row>
                    <el-row class="specDescription">User language in ISO format (en_US)</el-row>
                </el-col>
                <el-col :span="8" class="specControl">
                    
                    <el-select v-model="advanced.data.language_codes[0]"  size="mini" placeholder="select countries">
                        <el-option
                        v-for="item in languages"
                        :key="item"
                        :label="item"
                        :value="item">
                        </el-option>
                    </el-select>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="16">
                    <el-row>Profile tags</el-row>
                    <el-row class="specDescription">Choose tag to filter profiles by</el-row>
                </el-col>
                <el-col :span="8" class="specControl">
                                <el-row>
                                    <el-tag
                                        v-for="tag in advanced.data.include_tags"
                                        :key="tag"
                                        closable
                                        @close="handleCloseIncludeTags(tag)"
                                        >
                                        {{tag}}
                                    </el-tag>
                                </el-row>
                                <el-row>
                                    <el-col :span="16">
                                        <el-input v-model="tagIncludeInput" clearable=""></el-input>
                                    </el-col>
                                    <el-col :span="4">
                                        <el-button id="addTagButton" @click="addIncludeTag()" type="danger">Add</el-button>
                                    </el-col>
                                    <el-col :span="3">
                                    </el-col>
                                </el-row>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="16">
                    <el-row>Profile filtering option</el-row>
                    <el-row class="specDescription">the way to filter profiles</el-row>
                </el-col>
                <el-col :span="8" class="specControl">
                    
                    <el-select v-model="advanced.data.include_tags_option"  size="mini" placeholder="select filter">
                        <el-option
                        v-for="item in profileFilterOptions"
                        :key="item"
                        :label="item.name"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="16">
                    <el-row>Insufficient profile</el-row>
                    <el-row class="specDescription">Choose insufficient type</el-row>
                </el-col>
                <el-col :span="8" class="specControl">
                    <el-select id="insufficient_profile" v-model="advanced.data.insufficient_profile" size="mini" placeholder="Select insufficient">
                        <el-option
                            v-for="item in insufficiencies"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="16">
                    <el-row>Minimal age</el-row>
                    <el-row class="specDescription">Minimum age of the profile since creation</el-row>
                </el-col>
                <el-col :span="8" class="specControl">
                    <el-input class="advTextInputs" size="mini" v-model="advanced.data.minimal_age"></el-input>
                </el-col>
            </el-row>
            <el-row class="advancedHeader">Yandex auth</el-row>
            <el-row>
                <div v-if="advanced.data.accounts && advanced.data.accounts.length">
                    <el-tag        
                        v-for="tag in advanced.data.accounts[0].group_ids"
                        :key="tag"
                        closable
                        @close="removeGroup(tag)"
                        >
                        {{getGroupName(tag)}}
                    </el-tag>
                </div>
                <div v-else>No groups selected yet</div>
            </el-row>
            <el-row>
                <el-col :span="4">
                    <el-select id="groupId" v-model="selectedGroupId"  size="mini" placeholder="Select group id">
                        <el-option
                        v-for="item in accounts"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :span="4">
                    <el-button v-on:click="addSelectedGroup()" size="mini">Add group</el-button>
                </el-col>
                <el-col :span="16"></el-col>
            </el-row>
        </el-col>
    </el-row>
    </div>
</template>
<style>
    #OS{
        padding-left:10px;
        
    }
    .colTitle{
        margin-top:5px;
    }
    #recordVideo {
        font-size: 14px;
    }
    #videoInt{
        margin-top:-5px;
    }
    .text {
        font-size: 14px;
    }

    .item {
        margin-bottom: 18px;
    }

    .clearfix:before,
    .clearfix:after {
        display: table;
        content: "";
    }
    .clearfix:after {
        clear: both
    }

    .box-card {
        font-size:14px;
        width: 100%;
        margin-top:10px;
    }
    .advancedSettings {
        background-color:white;
        height:100%;
    }
    .asHeader {

    }
    .el-tag{
        margin:3px;
    }

    #browserTile{
        padding-left:15px;
    }

    .el-tag + .el-tag {
        margin-left: 10px;
    }
    .button-new-tag {
        margin-left: 10px;
        height: 32px;
        line-height: 30px;
        padding-top: 0;
        padding-bottom: 0;
    }
    .input-new-tag {
        width: 90px;
        margin-left: 10px;
        vertical-align: bottom;
        margin-top:-15px !important;
    }
    #firefox{
        margin-top:-5px;
    }
    #groupId{

    }
    .memo{
        padding:5px;
    }
    .colSets{
        margin-top:5px;
    }     
    .el-tag + .el-tag {
    margin-left: 10px;
    }
    .button-new-tag {
        margin-left: 10px;
        height: 32px;
        line-height: 30px;
        padding-top: 0;
        padding-bottom: 0;
    }
    .input-new-tag {
        width: 90px;
        margin-left: 10px;
        vertical-align: bottom;
    }
    .el-row {
        padding-top:5px;
        padding-bottom:5px;
    }
    .advancedHeader {
        font-size: 2em;
    }
    .specDescription {
        font-size: 0.8em;
        color: #777;
    }
    .specControl {
        margin-top:5px;
    }
    .elColCentered {
        text-align: center;
    }
    .advTextInputs{
        width: 70%;
    }
</style>
<script>
import 'element-ui/lib/theme-chalk/display.css';
import UiTags from './UiTags.vue';

export default {
    name: 'AdvancedSettings',
    computed: {
        includeTags: function () {
            if (this.advanced.data.include_tags.length)
                return this.advanced.data.include_tags;
            else 
                return [];
        },
        excludeTags: function () {
            if (this.advanced.data.exclude_tags.length)
                return this.advanced.data.exclude_tags;
            else 
                return [];
        },
    },
    mounted () {
    },
    created() {
        this.columnProps = {
            xl: {span: 12, offset: 0}, 
            lg: {span: 12, offset: 0},
            md: {span: 12, offset: 1},
            sm: {span: 12, offset: 1}
        }
    },
    props: {
        advanced: {
            type: Object,
            default: () => {}
        },
        accounts: {
            type: Array,
            default: () => []
        },
        proxies: {
            type: Array,
            default: () => []
        },
        proxies_tags: {
            type: Object,
            default: () => {}
        },
        languages: {
            type: Array,
            default: () => []
        },
        pools: {
            type: Array,
            default: () => []
        },
        type: {
            type: String,
            default: () => 'project'
        },
        bot: {
            type: Object,
            default: () => {}
        },
    },
    watch: {
        /**language_codes(newValue, oldValue) {
            this.advanced.data.language_codes = newValue.replace(/\r\n/g,"\n").split("\n");
        },
        country_codes(newValue, oldValue) {
            this.advanced.data.country_codes = newValue.replace(/\r\n/g,"\n").split("\n");
        },*/
    },
    methods:{
        resetToDefault() {
            this.drawer = false;
            this.$store.dispatch('project/deletePlaybookSettings', {
                project_id: this.bot.project_id, 
                bot_id: this.bot.id,
            });
        },
        getGroupName(id) {
            var filtered = this.accounts.filter(function(item){
                if (item.id == id) return item;
            });
            if(!filtered.length) return 'unknown group';
            return filtered[0].name;
        },
        removeGroup(id) {
            var accounts = this.advanced.data.accounts;
            var groupIds = accounts[0].group_ids;//assumed that we can only delete something when there is at least one record
            
            groupIds = groupIds.filter(function(item){
                if (item != id) return item;
            });
            var accounts = [];
            if (groupIds.length) {
                accounts = [{ "type": "yandex", "group_ids": groupIds }];
            }
            if (this.type == 'project') {
                this.$store.state.project.advanced.data.accounts = accounts;
            } else 
                this.$store.state.project.playbookAdvanced.data.accounts = accounts;
        },
        addSelectedGroup() {
            if (!this.advanced.data.accounts) {
                this.advanced.data.accounts = {};
            }

            var accounts = this.advanced.data.accounts;//[0].groupIds;
            
            if (!accounts.length) {
                var groupIds = [];   
            } else {
                groupIds = accounts[0].group_ids;
            }
            var that = this;//context handler for closure
            var intersect = groupIds.filter(function(item){
                if (item == that.selectedGroupId) return item;
            });

            if (intersect.length) {
                return 0;//already in array
            }
            groupIds.push(this.selectedGroupId);

            if(this.type == 'bot') {
                this.$store.state.project.playbookAdvanced.data.accounts = [ { "type": "yandex", "group_ids": groupIds }];
            } else 
                this.$store.state.project.advanced.data.accounts = [ { "type": "yandex", "group_ids": groupIds }];
        },
        handleCloseIncludeTags(tag) {
            this.advanced.data.include_tags.splice(this.advanced.data.include_tags.indexOf(tag), 1);
        },
        addIncludeTag() {
            if (this.tagIncludeInput.length) {
                this.advanced.data.include_tags.push(this.tagIncludeInput);
                this.tagIncludeInput = '';
            }
        },
        addTag() {
            if (this.tagInput.length) {
                this.advanced.data.proxy_tags.push(this.tagInput);
                this.tagInput = '';
            }
        },
        handleClose(tag) {
            this.advanced.data.proxy_tags.splice(this.advanced.data.proxy_tags.indexOf(tag), 1);

        },
        handleIncludeClose(tag) {
            this.includeTags.splice(this.includeTags.indexOf(tag), 1);
        },
        handleExcludeClose(tag) {
            this.excludeTags.splice(this.excludeTags.indexOf(tag), 1);
        },
        showIncludeInput() {
            this.inputIncludeVisible = true;
            this.$nextTick(_ => {
            this.$refs.saveTagInputInclude.$refs.input.focus();
            });
        },
        handleInputConfirmIncluded() {
            let inputValue = this.inputValueIncluded;
            if (inputValue) {
            this.includeTags.push(inputValue);
            }
            this.inputIncludeVisible = false;
            this.inputValueIncluded = '';
        },

        showExcludeInput() {
            this.inputExcludeVisible = true;
            this.$nextTick(_ => {
            this.$refs.saveTagInputExclude.$refs.input.focus();
            });
        },

        handleInputConfirmExcluded() {
            let inputValue = this.inputValueExcluded;
            if (inputValue) {
            this.excludeTags.push(inputValue);
            }
            this.inputExcludeVisible = false;
            this.inputValueExcluded = '';
        },
        getDefaultTableData() {
            return [
               
            ]
        },
        setChanged() {
            //compare with original
            this.hasChanged = true;
        },
        getLanguageCodes() {
            if (this.advanced.data.language_codes.length === 0) {
                return "";
            }

            return this.advanced.data.language_codes.join("\n");
        },
        getCountryCodes() {
            if (this.advanced.data.country_codes.length === 0) {
                return "";
            }

            return this.advanced.data.country_codes.join("\n");
        },
        handleClose(tag) {
            this.advanced.data.proxy_tags.splice(this.advanced.data.proxy_tags.indexOf(tag), 1);
        },
        saveAdvanced() {
            if (this.type == 'project') {
                var data = JSON.parse(JSON.stringify(this.advanced.data));
                //updateAdvanced
                var entity = this.advanced.data;
                
                if(!Array.isArray(entity.country_codes))
                    if (!entity.country_codes.length) {
                        entity.country_codes = [];
                    } else {
                        entity.country_codes = entity.country_codes.split(",");
                    }
                
                if(!Array.isArray(entity.language_codes))
                    if (!entity.language_codes.length) {
                        entity.language_codes = [];
                    } else {
                        var val = [];
                        val[0] = entity.language_codes;
                        entity.language_codes = val;
                    }

                entity.project_id = this.$route.params.id;
                this.$store.dispatch('project/updateAdvanced', entity);
            } else {
                this.advanced.data.project_id = this.bot.project_id;
                this.advanced.data.bot_id = this.bot.id;
                if(!Array.isArray(this.advanced.data.country_codes))
                    if (!this.advanced.data.country_codes.length) {
                        this.advanced.data.country_codes = [];
                    } else {
                        this.advanced.data.country_codes = this.advanced.data.country_codes.split(",");
                    }

                if(!Array.isArray(this.advanced.data.language_codes))
                    if (!this.advanced.data.language_codes.length) {
                        this.advanced.data.language_codes = [];
                    } else {
                        var val = [];
                        val[0] = this.advanced.data.language_codes;
                        this.advanced.data.language_codes = val;
                    }

                this.$store.dispatch('bot/setAdvanced', this.advanced.data);
            } 
        },

        saveBotSettings() {
            
        },
        
    },
    components: {
        UiTags
    },
    mounted: function () {
            this.settings =  this.$store.state.project.settings
            this.tags = JSON.parse(JSON.stringify(this.advanced.data.proxy_tags));
    },
    data() {
        return {
            selectedGroupId: '',
            selectedProxyTag: '',
            tagIncludeInput:'',
            tags:[],
            tagInput:'',
            language_codes: [],//this.getLanguageCodes(),
            pools: [],
            country_codes: [],// this.getCountryCodes(),
            settings: [],//this.$store.state.project.settings,
            inputIncludeVisible: false,
            inputExcludeVisible: false,
            inputValueIncluded: '',
            inputValueExcluded: '',
            checked:false,
            video_ratio: 0,
            retryNumOptions: [
                "auto", 0, 1, 2, 3, 4, 5
            ],
            profileFilterOptions: [
                {
                    name: 'All',
                    value: 'all'
                },
                {
                    name: 'One of',
                    value: 'one_of'
                },
                {
                    name: 'Equal to',
                    value: 'equal'
                },
            ],
            firefoxes: [
                {
                    name:'Firefox v115.5.0 Lopata Build',
                    value:'firefox115.5.0-lpt-build'
                },
                {
                    name:'Firefox v147.0.4 Lopata Build',
                    value:'firefox147.0.4-lpt-build'
                },
            ],
            insufficiencies : [
                {
                    name:'Create',
                    value:'create'
                },
                {
                    name:'Error',
                    value:'error'
                }
            ],
            osTypes: 
            [
                {
                    label: 'I don\t care',
                    options: 
                        [
                            {
                                name:'Any',
                                value:'any'
                            },
                        ]
                },
                {
                    label: 'Desktop systems',
                    options: 
                        [
                             {
                                name:'Any desktop',
                                value:'desktop_any'
                            },
                            {
                                name:'Windows',
                                value:'desktop_windows'
                            },
                            {
                                name:'MacOs',
                                value:'desktop_macos'
                            },
                            {
                                name:'Ubuntu',
                                value:'desktop_ubuntu'
                            },
                        ]
                }, 
                {
                    label: 'Mobile',
                    options: 
                        [
                            {
                                name:'Any mobile',
                                value:'mobile_any'
                            },
                            {
                                name:'iOS',
                                value:'mobile_ios'
                            },
                            {
                                name:'Android',
                                value:'mobile_android'
                            },
                            {
                                name:'Popka Test',
                                value:'mobile_popka'
                            },
                        ]
                },
            ],
        };
    }
}

</script>